module.exports = __webpack_public_path__ + "img/image (26).881bbdef.jpg";